class AnalyticsProvider {
  identify() {}
  track() {}
  screen() {}
  group() {}
}

export default AnalyticsProvider
